import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DatePicker, Radio } from '@node-space/ui-components'
import { useOnceOffExportContext } from 'hooks/context/useOnceOffExportContext'
import { customDateRadioOptions } from '../constants/exportOptions'

export const DateRangeSelector = () => {
  const { t } = useTranslation()
  const { formValues, setValue, exportCustomDateOptions, dateValue, setDateValue } =
    useOnceOffExportContext()

  const exportCustomDateRadioOptions = customDateRadioOptions(exportCustomDateOptions)

  const customDateFieldIsSelected =
    formValues.selectedDateOptionName === exportCustomDateOptions?.customDateRange?.name

  return (
    <>
      <Radio
        onChange={value => {
          setValue('selectedDateOptionName', value)
        }}
        options={exportCustomDateRadioOptions}
        value={formValues.selectedDateOptionName}
        border={false}
      />
      {customDateFieldIsSelected && (
        <Box paddingL={12}>
          <DatePicker
            mode="range"
            id="date-range-input"
            label={t('exports.dateOptions.dateRangeLabel')}
            placeholder={t('exports.dateOptions.dateRangeLabel')}
            initialSelected={dateValue}
            onSelect={date => setDateValue(date)}
          />
        </Box>
      )}
    </>
  )
}
